export default __webpack_public_path__ + "static/savaughn-51707c7ddfc9b12140aa9287a0899e1d.jpeg";